﻿export class ParticipantAnswerModel {
    selectedAnswers: {
        answerId: number;
        answerOptionId: number;
        text: string;
    }[];
    surveyQuestionId: number;
    surveyId: number;
    surveyParticipantId: number;
    ordNum: number;
}